
import { API_ROOT, uniquenessCheck } from '../../supplementary_components/requests';
import { isValidState, isValidZip, isValidPhoneNumber, phoneNumberTyping, isValidEmailAddress } from '../../supplementary_components/supplementaryMethods';
import { priceOnFinish, priceTypingProcess, percentageTypingProcess } from '../../supplementary_components/priceInputDelegate';

export function driverTypeFormatter(currentVal){
    switch (currentVal) {
        case "Company Driver":
            return 'Company';
        case "Owner Operator":
            return 'Owner';
        case "Lease Driver":
            return 'Lease';
        case 'Company':
            return "Company Driver";
        case 'Owner':
            return "Owner Operator";
        case 'Lease':
            return "Lease Driver";
        default: 
            return "Lease Driver";
    }
} 
export function driverPaymentTypeFormatter(currentVal){
    switch (currentVal) {
        case "Percentage":
            return 'Percentage';
        case "Per Mile":
            return 'PerMile';
        case "Salary":
            return 'Salary';
        case 'PerMile':
            return "Per Mile";
        case 'None':
            return "None";
        default: 
            return "Per Mile";
    }
} 

export const DRIVER_ADD_CONF = {

    formAccessLevel: { key: 'DRIVERS', level: 'MANAGE' },
    formTitle: "Add Driver",
    name: 'addDriverForm',
    addLink: API_ROOT+'drivers/add',
    successMessage:'Drivers was added',
    columns: [
        {
            label: "Driver Type",
            name: "driverType",
            type: "select",
            dataset: ["Company Driver", "Owner Operator", "Lease Driver"],
            processBeforeSending : driverTypeFormatter,
            onChange: event => {
                try {
                    const newDriverType = event.target.value;
                    let form = event.target; 
                    while (form.tagName !== "FORM" ){
                        form = form.parentNode;
                    }
                    const paymentSelect = form.querySelector('select[name="paymentType"]');
                    switch (newDriverType) {
                        case "Company Driver":
                            disableOptions(paymentSelect, [])
                            break;
                        case "Owner Operator":
                            disableOptions(paymentSelect, ["Per Mile", "Salary"])
                            paymentSelect.value = 'Percentage';
                            break;
                        case "Lease Driver":
                            disableOptions(paymentSelect, ["Per Mile", "Salary"]);
                            paymentSelect.value = 'Percentage';
                            break;
                        default:
                            break;
                    }
                    whenPaymentTypeChanged(form, paymentSelect.value)
                } catch (error) {
                    
                }
                
            }
        },
        {
            label: "First Name",
            name: "firstName",
            autoComplete:'off',
            mandatory: true,
        },
        {
            label: "Middle Name",
            name: "middleName",
        },
        {
            label: "Last Name",
            name: "lastName",
            autoComplete:'off',
            mandatory: true,
        },
        {
            label: "CDL Number",
            name: "licenseNumber",
            mandatory: true,
            checks : [
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    
                    resolve(uniquenessCheck(API_ROOT+"drivers/exists", "licenseNumber", value, "Driver with this CDL Number already exists", "CDL Number"));
                }),
            ]
        },
        {
            label: "Phone Number",
            name: "phoneNumber",
            mandatory: true,
            autoComplete:'off',
            filters:[
                phoneNumberTyping
            ],
            onblur:(val, tar)=>{
                return isValidPhoneNumber(val, tar);
            }
            
        },
        {
            label: "Email Address",
            name: "emailAddress",
            mandatory: true,
            autoComplete:'off',
            onblur:(val, target)=>{
                return isValidEmailAddress(val, target);
            }
        },
        {
            label: "Address Line 1",
            name: "addressLine1",
            autoComplete:'off',
        },
        {
            label: "Address Line 2",
            name: "addressLine2",
        },
        {
            label: "City",
            name: "city",
            autoComplete:'off',
        },
        {
            label: "State",
            name: "state",
            autoComplete:'off',
            onblur:(val, tar)=>{
                const newVal = isValidState(val);
                return newVal ? newVal : ''
            }
        },
        {
            label: "Postal Code",
            name: "postalCode",
            autoComplete:'off',
            onblur:(val)=>{
                const newVal = isValidZip(val);
                return newVal ? newVal : '';
            }
        },
        {
            label: "Payment Type",
            name: "paymentType",
            type: "select",
            dataset: ["Per Mile", "Percentage", "Salary", "None"],
            processBeforeSending : driverPaymentTypeFormatter,
            onChange: val => {
                let target = val.target; 
                while (target.tagName !== "FORM" ){
                    target = target.parentNode;
                }
                whenPaymentTypeChanged(target, val.target.value);
                
            },
            subMenu : {
                databaseColumnName: 'dbaInfo',
                title: "DBA Info",
                columnTemplate: "1fr ",
                columns : [
                    {
                        placeholder: "Company Name",
                        name: "dbaCompanyName",
                        autoComplete:'off',
                    },
                    {
                        placeholder: "Tax-ID",
                        name: "dbaTaxId",
                        autoComplete:'off',
                    },
                    {
                        placeholder: "Address Line 1",
                        name: "dbaAddressLine1",
                        autoComplete:'off',
                    },
                    {
                        placeholder: "Address Line 2",
                        name: "dbaAddressLine2",
                        autoComplete:'off',
                    },
                    {
                        placeholder: "City",
                        name: "dbaCity",
                        autoComplete:'off',
                    },
                    {
                        placeholder: "State",
                        name: "dbaState",
                        autoComplete:'off',
                        onblur:(val, tar)=>{
                            const newVal = isValidState(val);
                            return newVal ? newVal : ''
                        }
                    },

                    {
                        placeholder: "Postal Code",
                        name: "dbaPostalCode",
                        onblur:(val)=>{
                            const newVal = isValidZip(val);
                            return newVal ? newVal : '';
                        }
                    }
                ]
            }
        },
        {
            label: "Per Mile Rate",
            name: "perMileRate",
            mandatory: true,
            autoComplete:'off',
            
            defaultValue: ()=>{return "$0.70"},
            filters:[
                priceTypingProcess
            ],
            onblur:(val)=>{
                return priceOnFinish(val);
            },
            processBeforeSending:(val)=>{
                return parseFloat(val.replace(/[^0-9.]/g,''))
            },
        },
        {
            label: "Salary",
            name: "salaryPerWeek",
            mandatory: true,
            autoComplete:'off',
            customDisplayMode : "none",
            defaultValue: ()=>{return "$2,000.00"},
            filters:[
                priceTypingProcess
            ],
            onblur:(val)=>{
                return priceOnFinish(val);
            },
            processBeforeSending:(val)=>{
                return parseFloat(val.replace(/[^0-9.]/g,''))
            },
        },
        {
            label: "Gross Percentage",
            name: "percentageFromGross",
            mandatory: true,
            autoComplete:'off',
            customDisplayMode : "none",
            defaultValue: (e)=>{
                return "80%"
            },
            filters:[
                percentageTypingProcess
            ],
            onblur:(val)=>{
                return percentageTypingProcess(val);
            },
            processBeforeSending:(val)=>{
                return parseFloat(val.replace(/[^0-9.]/g,''))/100
            },
        },
    ]
}
function whenPaymentTypeChanged(target, newValue){
    function inputTypeToPaymentType(val){
        switch (val) {
            case "Percentage":
                return "percentageFromGross";
            case "Per Mile":
                return "perMileRate";
            case "None":
                return "none";
            default:
                return "salaryPerWeek";
        }
    }
    // function changeInputs(formTarget, currentlySelectedPaymentType){
        
    // }
    const fieldNames = ["perMileRate", "salaryPerWeek", "percentageFromGross"];
    for(let fieldName of fieldNames){
        let inputField = target.querySelector(`input[name="${fieldName}"]`);
        if(!inputField){
            inputField = target.querySelector(`select[name="${fieldName}"]`);
        }
        inputField.disabled = !inputTypeToPaymentType(newValue) === fieldName;
        inputField.parentNode.style.display = inputTypeToPaymentType(newValue) === fieldName ? "block" : "none";
    }
    
}
function disableOptions(selectTag, disableValues){
    try {
        Array.from(selectTag.options).forEach(option => {
            if (disableValues.includes(option.value)) {
                option.disabled = true;
                // Optional: If the disabled option was already selected, 
                // reset the select to the first available option
                // if (option.selected) {
                //     selectTag.selectedIndex = 0;
                // }
            }else{
                option.disabled = false;
            }
        });
    } catch (error) {
        
    }
    
    
}